import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResourcesGuideTennis = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 21C16.5229 21 21 16.5229 21 11C21 5.47715 16.5229 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5229 5.47715 21 11 21Z",
			stroke: "#198F58",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 1C10.9495 4.3341 10.1309 6.8348 8.5442 8.5022C6.9574 10.1696 4.44265 11.0036 1 11.0042",
			stroke: "#198F58",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9841 11.5026C17.7279 11.2793 15.2397 11.9753 13.5197 13.5906C11.7997 15.206 10.9603 17.6758 11.0014 21",
			stroke: "#198F58",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgResourcesGuideTennis;
